/**
 * MRL Cart Drawer UI Controller
 * Loads after the theme/cart bridge and owns ONLY drawer UI clicks.
 * This replaces legacy drawerfunction.js behavior.
 */
(function () {
  if (window.__MRL_CART_DRAWER_UI__) return;
  window.__MRL_CART_DRAWER_UI__ = true;

  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  function drawer() {
    return document.querySelector('.cart-drawer');
  }

  function drawerInner() {
    return document.querySelector('#cart-drawer');
  }

  function drawerSection() {
    return document.querySelector('#shopify-section-cart-drawer');
  }

  function open() {
    if (window.MRLCart && typeof window.MRLCart.openDrawer === 'function') {
      return window.MRLCart.openDrawer();
    }
    var el = drawer();
    if (!el) return;
    el.classList.add('cart-drawer--active');
    document.body.style.overflowY = 'hidden';
  }

  function close() {
    if (window.MRLCart && typeof window.MRLCart.closeDrawer === 'function') {
      return window.MRLCart.closeDrawer();
    }
    var el = drawer();
    if (!el) return;
    el.classList.remove('cart-drawer--active');
    document.body.style.overflowY = '';
  }

  async function refresh() {
    if (window.MRLCart && typeof window.MRLCart.refreshDrawer === 'function') {
      return window.MRLCart.refreshDrawer();
    }

    var current = drawerSection();
    if (!current) return;

    var res = await fetch(root() + '?section_id=cart-drawer', {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      cache: 'no-store'
    });
    var html = await res.text();
    var next = new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector('#shopify-section-cart-drawer');

    if (next) current.innerHTML = next.innerHTML;
  }

  async function change(lineItemKey, quantity) {
    if (window.MRLCart && typeof window.MRLCart.changeItem === 'function') {
      return window.MRLCart.changeItem(lineItemKey, quantity, {
        refreshDrawer: true
      });
    }

    var res = await fetch(root() + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        id: lineItemKey,
        quantity: quantity
      })
    });
    var cart = await res.json().catch(function () { return {}; });
    if (!res.ok || cart.status) {
      throw new Error(cart.description || cart.message || 'Cart update failed');
    }
    await refresh();
    return cart;
  }

  function setBusy(button, isBusy) {
    if (!button) return;
    button.disabled = isBusy;
    button.setAttribute('aria-busy', isBusy ? 'true' : 'false');
  }

  async function removeItem(button) {
    var item = button.closest('[data-line-item-key]');
    if (!item) return;
    var key = item.getAttribute('data-line-item-key');
    if (!key) return;

    setBusy(button, true);
    try {
      await change(key, 0);
    } catch (err) {
      console.error('[MRL Drawer UI] Remove failed:', err);
    } finally {
      setBusy(button, false);
    }
  }

  async function changeQty(button) {
    var item = button.closest('[data-line-item-key]');
    if (!item) return;
    var key = item.getAttribute('data-line-item-key');
    if (!key) return;

    var qtyEl = item.querySelector('.quantity');
    var currentQty = qtyEl ? parseInt(qtyEl.textContent, 10) || 1 : 1;
    var isIncrease = button.classList.contains('increase') || button.matches('[data-qty-increase]');
    var nextQty = isIncrease ? currentQty + 1 : Math.max(currentQty - 1, 0);

    setBusy(button, true);
    try {
      await change(key, nextQty);
    } catch (err) {
      console.error('[MRL Drawer UI] Quantity failed:', err);
    } finally {
      setBusy(button, false);
    }
  }

  document.addEventListener('click', function (event) {
    var cartOpen = event.target.closest('.drawer-button, .icon2, [data-cart-open]');
    if (cartOpen) {
      event.preventDefault();
      event.stopPropagation();
      open();
      return;
    }

    var activeDrawer = drawer();
    if (!activeDrawer) return;

    var closeBtn = event.target.closest('.cart-drawer-header-right-close, .cart-drawer .close-btn, #Continue');
    if (closeBtn) {
      event.preventDefault();
      event.stopPropagation();
      close();
      return;
    }

    var removeBtn = event.target.closest('.cart-drawer .remove-btn, .cart-drawer [data-cart-remove]');
    if (removeBtn) {
      event.preventDefault();
      event.stopPropagation();
      removeItem(removeBtn);
      return;
    }

    var qtyBtn = event.target.closest('.cart-drawer .increase, .cart-drawer .decrease, .cart-drawer [data-qty-increase], .cart-drawer [data-qty-decrease]');
    if (qtyBtn) {
      event.preventDefault();
      event.stopPropagation();
      changeQty(qtyBtn);
      return;
    }

    if (!activeDrawer.classList.contains('cart-drawer--active')) return;
    var inner = drawerInner();
    if (inner && inner.contains(event.target)) return;
    close();
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close();
  });

  window.MRLCartDrawerUI = {
    open: open,
    close: close,
    refresh: refresh
  };

  window.openCartDrawer = open;
  window.closeCartDrawer = close;
})();